module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/boy-doll-51777a9df2ee0fcb3fbd45263d983f53.png";